// src/utils/storageHelpers.ts
import { secureGetItem } from "./encryption";

export const getSecureDevId = (): number => {
  try {
    const devId = secureGetItem("devID");
    
    // Handle different possible formats
    if (devId === null || devId === "null" || devId === undefined) {
      return -1;
    }
    
    if (typeof devId === 'number') {
      return devId;
    }
    
    if (typeof devId === 'string') {
      const parsed = parseInt(devId, 10);
      return isNaN(parsed) ? -1 : parsed;
    }
    
    return -1;
  } catch (error) {
    console.error("Error getting secure devID:", error);
    
    // Fallback to localStorage
    try {
      const devId = localStorage.getItem("devID");
      if (devId === null || devId === "null") {
        return -1;
      }
      const parsed = parseInt(devId, 10);
      return isNaN(parsed) ? -1 : parsed;
    } catch (fallbackError) {
      console.error("Fallback also failed:", fallbackError);
      return -1;
    }
  }
};